<template>
  <!-- プロフィール表示下部(アイコン/名前/詳細情報) -->
  <div class="c-blogProfile">
    <nuxt-link
      :to="`/blogs/${user.id}`"
      class="c-blogProfile_writer"
    >
      <c-user-icon-v2
        :file-path="user.resizableProfileIcon"
        :size="isPC ? 60 : 32"
      />
      <div class="c-blogProfile_heading">
        <div class="c-blogProfile_name">{{ user.name }}</div>
        <div class="c-blogProfile_ocupation">
          <span v-if="user.profile.occupation">{{ user.profile.occupation }} / </span>
          <span>{{ corporateFgText }}</span>
          <span v-if="user.profile && user.profile.isDisplayAge && user.age"> / {{ user.age }}</span>
          <span v-if="user.sex"> / {{ sexText }}</span>
          <span v-if="prefectureText"> / {{ prefectureText }}</span>
        </div>
      </div>
    </nuxt-link>
    <div
      v-if="isPC"
      class="c-blogProfile_action"
    >
      <div
        v-if="!isOwner"
        class="c-blogProfile_actionMenu"
      >
        <action-menu v-if="isLoggedIn" />
        <c-button
          v-if="!isBlockee"
          :is-active="!user.userRelation.followingFlag"
          :icon-name="!user.userRelation.followingFlag ? 'user-plus' : 'user-check'"
          @click="toggleFollow"
        >{{ !user.userRelation.followingFlag ? 'フォローする' : 'フォロー中' }}</c-button>
      </div>
      <div v-if="isOwner">
        <p
          class="c-blogProfile_customizeStatus"
          :class="{ 'c-blogProfile_customizeStatus-isStop': isStopCustomize }"
        >
          見積り・仕事の相談：{{ customizeStatusText }}
          <coconala-icon name="circle" />
        </p>
        <c-button
          class="c-blogProfile_editBtn"
          color="secondary"
          is-outlined
          @click="$router.push('/mypage/user')"
        >
          自分のページを編集する
        </c-button>
      </div>
      <div v-else>
        <customize-button
          class="c-blogProfile_customizeBtn"
          :user-id="user.id"
          :origin="CUSTOMIZE_ORIGINS.PROFILE"
        />
        <c-button
          class="c-blogProfile_messageBtn"
          :href="$coconala.directMessageURL(user.id)"
          :target="isSP ? '_self' : '_blank'"
          @click="onClickDM"
        >メッセージを送る</c-button>
      </div>
    </div>
    <div v-if="isSP || isTB">
      <c-button
        v-if="!isBlockee && !isOwner"
        :is-active="!user.userRelation.followingFlag"
        :icon-name="!user.userRelation.followingFlag ? 'user-plus' : 'user-check'"
        @click="toggleFollow"
      >{{ !user.userRelation.followingFlag ? 'フォローする' : 'フォロー中' }}</c-button>
    </div>
  </div>
</template>
<script>
import CustomizeButton from '~/components/molecules/buttons/CustomizeButton'
import ActionMenu from '~/components/organisms/TheProfileCard/components/ActionMenu'

// mixins
import formMixin from '~/mixins/form-mixin'

// vuex
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'BlogProfile',
  mixins: [formMixin],
  components: {
    CustomizeButton,
    ActionMenu
  },
  methods: {
    ...mapActions('ui', ['showLoginModal']),
    ...mapActions('pages/users/user', ['addFollow', 'deleteFollow']),
    onClickDM(e) {
      if (!this.isLoggedIn) {
        e.preventDefault()
        this.showLoginModal()
      }
      if (this.isBlockee) {
        e.preventDefault()
        this.$notify({
          group: 'flash',
          type: 'warn',
          title: 'このユーザーにはメッセージを送信できません'
        })
      }
    },
    async toggleFollow() {
      if (!this.isLoggedIn) return this.showLoginModal()
      if (this.user.userRelation.followingFlag) {
        await this.deleteFollow()
        this.doNotifySuccess('フォローを解除しました')
      } else {
        await this.addFollow()
        this.doNotifySuccess('フォローしました')
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isFromCoconalaApp', 'isLoggedIn']),
    ...mapGetters('ui', ['isPC', 'isSP', 'isTB']),
    ...mapState('constants', ['CUSTOMIZE_ORIGINS']),
    isOwner() {
      return this.$store.getters['pages/users/isOwner']
    },
    prefectureText() {
      return this.$store.getters['pages/users/user/prefectureText']
    },
    sexText() {
      return this.$store.getters['pages/users/user/sexText']
    },
    corporateFgText() {
      return this.$store.getters['pages/users/user/corporateFgText']
    },
    user() {
      return this.$store.state.pages.users.user
    },
    isBlockee() {
      return this.user.userRelation && this.user.userRelation.blockeeFlag
    },
    isStopCustomize() {
      return this.user.userStatus && this.user.userStatus.isStopCustomize
    },
    customizeStatusText() {
      return this.isStopCustomize ? '休止中' : '受付中'
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blogProfile {
  display: flex;
  margin-bottom: 12px;
  padding: 24px 0 28px;
  border-top: 1px solid $color-gray-200;

  &_writer {
    display: flex;
    @include link-effect;
  }

  &_heading {
    margin-left: 12px;
  }

  &_name {
    font-size: 16px;
    font-weight: bold;
    color: $color-gray-900;
  }

  &_ocupation {
    font-size: 12px;
    color: $color-gray-600;
  }

  &_action {
    margin-left: auto;
    width: 192px;
  }

  &_actionMenu {
    display: inline-flex;
    margin-bottom: 8px;
    padding-bottom: 8px;
    align-items: center;
    width: 100%;
    justify-content: space-around;
    border-bottom: 1px solid $color-gray-200;
    button {
      @include link-effect;
    }
  }

  &_editBtn {
    width: 100%;
  }

  &_customizeBtn {
    width: 100%;
  }

  &_messageBtn {
    margin-top: 8px;
    width: 100%;
    @include link-effect;
  }

  &_customizeStatus {
    margin-bottom: 12px;
    width: 100%;
    text-align: center;
    font-size: 12px;

    .-circle {
      display: inline-block;
      margin-left: -2px;
      color: $color-green-500;
      vertical-align: -2px;
      font-size: 14px;
      transform: scale(0.5);
    }

    &-isStop {
      .-circle {
        color: $color-gray-300;
      }
    }
  }
}

@media (max-width: $breakpoint-m) {
  .c-blogProfile {
    margin-bottom: 0;
    padding-bottom: 0;
    display: block;
    text-align: center;

    &_name {
      text-align: left;
      font-size: 14px;
      font-weight: normal;
    }

    &_heading {
      margin-bottom: 16px;
    }

    &_ocupation {
      font-size: 11px;
    }
  }
}
</style>
